<template>
  <div class="content-item flex">
    <div class="content-item-label"><span class="red">*</span>付费情况</div>
    <el-radio-group v-model="radio" class="flex align-items-center">
      <el-radio :label="1">自费</el-radio>
      <el-radio :label="2">免费</el-radio>
      <el-radio :label="3">依据当地防疫情况而定</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "payment",
  props: ['value'],
  computed: {
    radio: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
